import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory, Link } from "react-router-dom";
import { useExtensionLogin } from "@elrondnetwork/dapp";
import * as Dapp from "@elrondnetwork/dapp";

const LoginStyle = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrapper-button-mint {
    width: 272px;
  }
  button {
    background: #083dc1;
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    padding: 15px 20px;
    border-radius: 30px;
    color: white;
    margin-top: 32px;
    transition: transform 0.5s;
    box-shadow: 0px 0px 40px rgba(8, 61, 193, 0.5);
    span {
      padding-left: 10px;
    }
    img {
      width: 36px;
      height: 20px;
      padding: 4px;
      background-color: white;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
`;

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null;
}

export default function Login() {
  const callbackRoute = "/";
  const token = "";
  const dapp = Dapp.useContext();

  const extensionLogin = useExtensionLogin({ callbackRoute, token });
  let history = useHistory();

  useEffect(() => {
    const params = {
      discordId: getQueryVariable("discordId"),
      address: getQueryVariable("address"),
    };
    if (dapp.address || params.address) {
      window.parent.postMessage(
        { userLogin: true, erd: dapp.address || params.address },
        "*"
      );
    }
    window.localStorage.clear();
  }, [dapp.address]);

  return (
    <LoginStyle className="text-white font-thin">
      <div>
        <p class="text-[24px] font-thing sm:text-[36px]">
          Connect <span className="font-bold text-[#96FF9A]">your wallet</span>
          <br />
          to view your NFT’s
        </p>
      </div>
      <p className="pt-8 font-">Please select your login method:</p>
      <div className="wrapper-button-mint">
        <button onClick={extensionLogin}>
          <img src="/img/wallet-connect/maiar.svg" alt="Logo Maiar" />
          <span>Maiar DeFi Wallet</span>
        </button>
        <button
          onClick={() => {
            history.push("/wallet/connect");
          }}
        >
          <img src="/img/wallet-connect/maiar.svg" alt="Logo Elrond" />
          <span>Maiar App</span>
        </button>
      </div>
    </LoginStyle>
  );
}
